import { AvsCtaPill, AvsCtaPillProps } from './AvsCtaPill';
import { useGetReadyAvsCountQuery } from './useGetReadyAvsCountQuery';

export function AvsCtaPillWrapper(props: Pick<AvsCtaPillProps, 'className'>) {
  const { data, loading } = useGetReadyAvsCountQuery();
  const numSummaries = data?.afterVisitSummariesReady?.totalReadyForReview ?? 0;

  if (loading) return;

  return <AvsCtaPill {...props} numSummaries={numSummaries} />;
}
